import React, { useEffect, useState } from "react";
import { useConsultationWizardState } from "../../../hooks/useConsultationWizardState";

// Composants UI
import { BackgroundDecoration } from "../../ui/BackgroundDecoration";
import { FormContainer } from "../../ui/FormContainer";
import { FormHeader } from "../../ui/FormHeader";

// Composants de section
import { MotherInfoSection } from "../../PediatricsRegistrationSections/MotherInfoSection";
import { FatherInfoSection } from "../../PediatricsRegistrationSections/FatherInfoSection";
import { PrenatalBirthSection } from "../../PediatricsRegistrationSections/PrenatalBirthSection";
import { PregnancyConsumptionSection } from "../../PediatricsRegistrationSections/PregnancyConsumptionSection";
import { SocialLifeSection } from "../../PediatricsRegistrationSections/SocialLifeSection";

/* eslint-disable @typescript-eslint/no-empty-object-type */
interface PediatricsRegistrationStepProps {
  // Add properties here if needed
}
/* eslint-enable @typescript-eslint/no-empty-object-type */

const PediatricsRegistrationStep: React.FC<PediatricsRegistrationStepProps> = () => {
  const { formData, updateFormData } = useConsultationWizardState();
  const [currentDate] = useState(new Date().toISOString().split("T")[0]);

  const updatePediatricsInfo = React.useCallback((key: string, value: any) => {
    updateFormData("pediatrieInfo", key, value);
  }, [updateFormData]);

  const updateVieSociale = (key: string, value: any) => {
    updateFormData("vieSociale", key, value);
  };

  useEffect(() => {
    if (!formData.pediatrieInfo?.dateEnregistrement) {
      updatePediatricsInfo("dateEnregistrement", currentDate);
    }
  }, [
    currentDate,
    formData.pediatrieInfo?.dateEnregistrement,
    updatePediatricsInfo,
  ]);

  return (
    <div className="space-y-8">
      <BackgroundDecoration />

      <FormContainer>
        <FormHeader
          title="Enregistrement Pédiatrie"
          subtitle="Nouveau patient pédiatrique"
        />

        <MotherInfoSection
          formData={formData}
          updatePediatricsInfo={updatePediatricsInfo}
        />

        <FatherInfoSection
          formData={formData}
          updatePediatricsInfo={updatePediatricsInfo}
        />

        <PrenatalBirthSection
          formData={formData}
          updatePediatricsInfo={updatePediatricsInfo}
        />

        <PregnancyConsumptionSection
          formData={formData}
          updatePediatricsInfo={updatePediatricsInfo}
        />

        <SocialLifeSection
          formData={formData}
          updatePediatricsInfo={updatePediatricsInfo}
          updateVieSociale={updateVieSociale}
        />
      </FormContainer>
    </div>
  );
};

export default PediatricsRegistrationStep;
